<template>
    <accordion>
        <template slot="toggle-title">
            {{ title }}
            <span
                v-if="status"
                class="flex items-center text-sm text-neutral-dark font-regular mt-xs md:mt-0 md:ml-xl"
            >
                <font-awesome-icon
                    icon="circle"
                    :class="`is-small text-xs text-${status[1]} mr-sm`"
                />
                {{ status[0] }}
            </span>
        </template>
        <template slot="extra-text">
            <span v-if="extraText">{{ extraText }}</span>
            <span v-else-if="price" class="font-bold text-neutral-darker hidden md:inline-flex">{{ price }}</span>
        </template>

        <template v-slot:toggle-content="{ toggle }">
            <slot :toggle="toggle" />
        </template>
    </accordion>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            status: {
                type: Array,
                default: null,
            },
            extraText: {
                type: String,
                default: null,
            },
            price: {
                type: String,
                default: null,
            },
        },
    };
</script>